import React from 'react';
import { PageProps } from 'gatsby';
import Layout from '../components/layout/Layout';
import SEO from '../components/SEO';
import Section from '../components/layout/Section';
import {
  BodyText,
  Heading2,
  LinkText,
  Subtitle,
} from '../components/Typography';
import Footer2 from '../components/layout/Footer2';
import HeaderNav from '../components/HeaderNav';
import { formatPhoneNumber } from '../components/PhoneNumber';
import { tele, whtapp } from '../constants/lines';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';

const PrivacyPage: React.FC<PageProps> = () => {
  return (
    <Layout>
      <HeaderNav />
      <div className="bg-bg pt-16" />
      <Section className="pt-16">
        <Subtitle className="mb-4 uppercase tracking-wider">
          Privacy Policy
        </Subtitle>
        <BodyText className="mb-4 mt-6">
          THE DATA PROTECTION REFERENCE NUMBER: ZB231109 START DATE: 6 OCTOBER
          2021 END DATE: 5 OCTOBER 2022
        </BodyText>
        <BodyText className="mb-4">Last updated: 30/11/2024</BodyText>
        <BodyText className="mb-4">
          MB AUTOCARE GARAGE LTD ("us", "we", or "our") operates the
          www.mbautocaregarage.co.uk website (hereinafter referred to as the
          "service").
        </BodyText>
        <BodyText className="mb-4">
          This page informs you of our policies regarding the collection, use,
          and disclosure of personal data when you use our service and the
          choices you have associated with that data.
        </BodyText>
        <BodyText className="mb-4">
          We use your data to provide and improve the service. By using the
          service, you agree to the collection and use of information in
          accordance with this policy.
        </BodyText>

        <Heading2 className="mb-4 mt-6">
          Information Collection And Use
        </Heading2>
        <BodyText className="mb-4">
          We collect several different types of information for various purposes
          to provide and improve our service to you.
        </BodyText>

        <Heading2 className="mb-4 mt-6">Types of Data Collected</Heading2>
        <BodyText className="mb-4">
          Personal Data: While using our service, we may ask you to provide us
          with certain personally identifiable information that can be used to
          contact or identify you ("Personal Data"). This may include:
          <ul className="ml-6 list-disc">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, Postal code, City</li>
            <li>Car details such as make, model, and registration number</li>
          </ul>
        </BodyText>

        <Heading2 className="mb-4 mt-6">Use of Data</Heading2>
        <BodyText className="mb-4">
          MB AUTOCARE GARAGE LTD uses the collected data for various purposes:
          <ul className="ml-6 list-disc">
            <li>To provide and maintain the service</li>
            <li>To notify you about changes to our service</li>
            <li>To provide customer care and support</li>
            <li>To monitor the usage of the service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>
        </BodyText>

        <Heading2 className="mb-4 mt-6">Contact Us</Heading2>
        <BodyText className="mb-4">
          If you have any questions about this Privacy Policy, please contact
          us:
        </BodyText>
        <BodyText className="mb-4">
          <LinkText
            className="font-normal"
            to={`whatsapp:${whtapp}`}
            Icon={FaWhatsapp}
          >
            {formatPhoneNumber(whtapp)}
          </LinkText>
        </BodyText>
        <BodyText className="mb-4">
          <LinkText className="font-normal" to={`tel:${tele}`} Icon={FaPhone}>
            {formatPhoneNumber(tele)}
          </LinkText>
        </BodyText>
      </Section>
      <Footer2 />
    </Layout>
  );
};

export default PrivacyPage;

export const Head = () => <SEO title="Privacy Policy" />;
